export const FTMarketIds = {
    ML: "1_",
    HC: "2_",
    OU: "3_"
};
//# sourceMappingURL=FTMarketIds.js.map